import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useParams } from 'react-router-dom';

import { getCourseById } from 'store/course/actions';
import { currentCourseSelector } from 'store/course/selectors';

import { getTranslation } from 'helpers/getTranslation';

import CoursePreviewPage from './CoursePreviewPage';

const CoursePreviewPageContainer = () => {
  const dispatch = useAppDispatch();

  const { id: courseId } = useParams();

  const course = useAppSelector(currentCourseSelector);

  const [loading, setLoading] = useState(true);
  const [previewType, setPreviewType] = useState(
    getTranslation('common.text.plugin'),
  );

  useEffect(() => {
    const _getCourseById = async () => {
      try {
        await dispatch(getCourseById(courseId)).unwrap();
      } catch (error) {
        console.warn(error);
      }

      setLoading(false);
    };

    _getCourseById();
  }, []);

  return (
    <CoursePreviewPage
      loading={loading}
      course={course}
      previewType={previewType}
      setPreviewType={setPreviewType}
    />
  );
};

export default React.memo(CoursePreviewPageContainer) as any;
